import { render } from "./TimeoutFacturaDialog.vue?vue&type=template&id=bd28ef8c&scoped=true"
import script from "./TimeoutFacturaDialog.vue?vue&type=script&lang=js"
export * from "./TimeoutFacturaDialog.vue?vue&type=script&lang=js"

import "./TimeoutFacturaDialog.vue?vue&type=style&index=0&id=bd28ef8c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd28ef8c"]])

export default __exports__